import { getSucursalUuid, getCajaId } from './contexto'

export function sucursalUuid(state) {
    return getSucursalUuid();
}
export function caja_id_cookie(state) {
    return getCajaId();
}
